import { BToast, BSpinner } from 'bootstrap-vue'
import defaultTable from '@/components/layout/defaultTable/DefaultTable.vue'
import constants from '@/util/constants'
import { mapState } from 'vuex'
import util from '@/util'

export default {
  name: 'negociadores',
  components: {
    'b-toast': BToast,
    'b-spinner': BSpinner,
    'default-table': defaultTable
  },

  computed: {
    ...mapState('usuarios', ['listaNegociadoresDoUsuario', 'possuiNegociador', 'dadosRetorno', 'flagsDeControle'])
  },

  data: () => {
    return {
      idUsuario: null,
      timeOutDigitacaoNocombo: null,

      comboNegociadoresDisponiveis: [],
      listaNegociadoresDisponiveis: [],
      negociadorSelecionado: null,
      fields: [
        { key: 'f_name', sortable: false, label: 'Nome' },
        { key: 'opcoes', sortable: false, label: 'Opções' }
      ]
    }
  },

  mounted () {
    this.limparListaErros()
    this.idUsuario = this.$route.params.id
    this.obterNegociadoresDisponiveis()
  },

  methods: {
    tabelaSemRegistros (item, type) {
      if (util.valorVazio(item) && type === 'row-empty') {
        return 'text-center'
      }
    },

    eventoDigitarBuscaPorNegociadores (valorDigitadoParaBusca, callbackFlagCarregamento) {
      this.limparListaErros()

      clearTimeout(this.timeOutDigitacaoNocombo)
      let referenciaObjetoDaView = this

      this.timeOutDigitacaoNocombo = setTimeout(function () {
        referenciaObjetoDaView.obterNegociadoresDisponiveis(valorDigitadoParaBusca, callbackFlagCarregamento)
      }, constants.tempoParaAguardarDigitacaoNoCombo)
    },

    async obterNegociadoresDisponiveis (valorDigitadoParaBusca, callbackFlagCarregamento) {
      if (!util.valorEhNulo(callbackFlagCarregamento)) {
        callbackFlagCarregamento = true
      }

      let parametrosRequisicao = {
        'registrosPorPagina': constants.defaultRegistrosCombo,
        'filtros': { 'f_name': valorDigitadoParaBusca }
      }
      const resposta = await this.axios.post('/areas', parametrosRequisicao)
      this.listaNegociadoresDisponiveis = resposta.data.retorno.dados
      this.comboNegociadoresDisponiveis = this.listaNegociadoresDisponiveis.map(function (registro) {
        return { label: registro.f_name, code: registro.f_id }
      })
      callbackFlagCarregamento = false
    },

    adicionarNaLista () {
      this.limparListaErros()

      if (util.valorEhNulo(this.negociadorSelecionado)) {
        this.dadosRetorno.listaDeErros['agreement_users_areas'] = 'Selecione uma área'
      } else {
        let listaNegociadores = this.listaNegociadoresDoUsuario
        const temNegociador = listaNegociadores.some((area) => area.f_id === this.negociadorSelecionado.code)

        if (temNegociador) {
          this.dadosRetorno.listaDeErros['agreement_users_areas'] = 'Esta área já foi adicionada'
        } else {
          const obj = {
            'f_id': this.negociadorSelecionado.code,
            'f_name': this.negociadorSelecionado.label
          }
          this.listaNegociadoresDoUsuario.push(obj)
        }
      }
      this.resetarAutoComplete()
    },

    limparListaErros () {
      this.dadosRetorno.listaDeErros = {}
    },

    resetarAutoComplete () {
      this.negociadorSelecionado = null
    },

    excluirDaLista (item) {
      const indice = this.listaNegociadoresDoUsuario.map(
        function (elemento) {
          return elemento.f_id
        }).indexOf(item.f_id)
      if (indice !== -1) {
        this.listaNegociadoresDoUsuario.splice(indice, 1)
      }
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    }
  }
}
